import React from "react";
import Button from "../../../../_components/Button";
import Text from "../../../../_components/Text";
import Modal from "../../../../_components/Modal";
import Checkbox from "../../../../_components/Checkbox";
import LoadingInput from "../../../../_components/LoadingInput";
import { unSubscribe } from "../../../../api/plans";
import { showSnackBar } from "../../../../utils";

const REASONS = [
  {
    reason: "Não consegui emitir nota fiscal",
    checked: false,
  },
  {
    reason: "Quero trocar de plano",
    checked: false,
  },
  {
    reason: "Achei as telas confusas",
    checked: false,
  },
  {
    reason: "Sistema não me agradou",
    checked: false,
  },
  {
    reason: "Não consegui fazer vendas",
    checked: false,
  },
  {
    reason: "Não consegui gerenciar o meu estoque",
    checked: false,
  },
  {
    reason: " Apenas teste ...",
    checked: false,
  },
  {
    reason: " Upgrade de assinatura",
    checked: false,
  },
  {
    reason: " Downgrade de assinatura",
    checked: false,
  },
  {
    reason: "Outro",
    checked: false,
  },
];

export default (props) => {
  const [show, setShow] = React.useState(false);
  const [rate, setRate] = React.useState(3);
  const [fakeRate, setFakeRate] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [reasons, setReasons] = React.useState([]);
  const [otherReason, setOtherReason] = React.useState("");

  function onChange(key, value) {
    if (loading) {
      return;
    }
    const bkp = reasons;
    bkp[key].checked = value;
    setReasons([...bkp]);
  }
  function onClose() {
    setOtherReason(REASONS);
    setOtherReason("");
    setShow(false);
  }
  function canUnSubscribe() {
    document.getElementById(
      "unsubscribe-feedback-error-alsh11idlka"
    ).innerText = "";
    if (reasons.filter((reason) => reason.checked === true).length === 0) {
      document.getElementById(
        "unsubscribe-feedback-error-alsh11idlka"
      ).innerText = "Selecione ao menos uma opção abaixo";
      return;
    }
    if (loading) {
      return;
    }
    let reasonsCollected = reasons
      .filter((reason) => reason.checked === true)
      .map((reason) => reason.reason)
      .join(", ");
    reasonsCollected += ` ${otherReason}`;
    const data = {
      rate: rate,
      reason: reasonsCollected.toLocaleLowerCase(),
    };
    setLoading(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
    unSubscribe(data)
      .then(() => {
        showSnackBar("Assinatura cacelada!", "info");
        setTimeout(() => {
          location.reload();
        }, 2000);
      })
      .catch((error) => {
        let message = "";
        if (typeof error === "object") {
          message = `Não foi possível encerrar a assinatura: ${JSON.stringify(
            error.error
          )}`;
        } else {
          message = `Não foi possível encerrar a assinatura: ${error.error}`;
        }
        document.getElementById(
          "unsubscribe-feedback-error-alsh11idlka"
        ).innerText = message;
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 2500);
      });
  }
  React.useEffect(() => {
    setReasons(REASONS);
  }, []);

  return (
    <React.Fragment>
      <Button onClick={() => setShow(true)} as="text" className="text-dark">
        Cancelar Assinatura
      </Button>
      <Modal show={show} title="Cancelar Assinatura" onHide={onClose}>
        <Text
          className="my-2 text-danger text-center"
          id="unsubscribe-feedback-error-alsh11idlka"
        />
        <Text className="text-danger text-center">
          Algumas funcionalidades do sistema não poderão ser acessadas sem a
          assinatura de um plano.
        </Text>
        <Text className="text-center py-1">
          Antes de cancelar sua assinatura gostaríamos de saber o motivo a sua avaliação do nosso sistema.
        </Text>
        <div className="d-flex justify-content-center">
          {[1, 2, 3, 4, 5].map((thisRate, index) => {
            return (
              <i
                style={{ cursor: "pointer" }}
                onMouseEnter={() => setFakeRate(thisRate)}
                onMouseLeave={() => setFakeRate(undefined)}
                onClick={() => setRate(thisRate)}
                className={`fas fa-star px-2 ${
                  fakeRate >= thisRate  || rate >= thisRate ? "text-warning" : ""
                }`}
                key={`cancel-plan-rate-${rate}-${index}`}
              />
            );
          })}
          { fakeRate === 1 ? <span>🫠</span> : <React.Fragment /> }
          { fakeRate === 2 ? <span>🫤</span> : <React.Fragment /> }
          { fakeRate === 3 ? <span>😀</span> : <React.Fragment /> }
          { fakeRate === 4 ? <span>😁</span> : <React.Fragment /> }
          { fakeRate === 5 ? <span>🥰</span> : <React.Fragment /> }
        </div>
        <ul
          className="list-group my-4"
          style={
            loading
              ? {
                  opacity: 0.3,
                  cursor: "not-allowed",
                }
              : {}
          }
        >
          {reasons.map((reason, idx) => {
            return (
              <li
                className="list-group-item"
                key={`cancel-subscription-reason-${idx}`}
              >
                <Text className="d-flex">
                  <Checkbox
                    itemKey={idx}
                    onClick={onChange}
                    checked={reason.checked}
                  />
                  {reason.reason}
                </Text>
              </li>
            );
          })}
        </ul>
        <div
          className={`${
            reasons[9]
              ? reasons[9].checked
                ? "form-group"
                : "d-none"
              : "d-none"
          }`}
        >
          <div className="form-label">
            <Text>Informe o motivo abaixo:</Text>
            <LoadingInput
              loading={loading}
              value={otherReason}
              onChange={(e) => setOtherReason(e.target.value)}
            />
          </div>
        </div>
        <Button
          disabled={loading}
          onClick={canUnSubscribe}
          as="text"
          className="text-danger"
        >
          Cancelar Assinatura
        </Button>
      </Modal>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/Plans/CancelPlan/index.jsx